export const CHECK_SERVICE_EVENT = 'service-picker-widget/check-service';
export const PUBLISH_PAYMENT_STARTED_EVENT = 'service-picker-widget/publish-payment-started';
